import { useMemo } from 'react';
import { selectBuilderInfo } from '../selectors/analyses';
import { useAppSelector } from '../hooks';
import { MaybeNil } from '../../utils/interfaces';

const useAnalysisBuilderInfo = (analysisId: MaybeNil<string>) => {
  const analysisBuilderInfoMemoizedSelector = useMemo(selectBuilderInfo, []);
  return useAppSelector((state) =>
    analysisBuilderInfoMemoizedSelector(state, analysisId),
  );
};

export default useAnalysisBuilderInfo;
